import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import Radio from '@material-ui/core/Radio'
import RadioGroup from '@material-ui/core/RadioGroup'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import FormControl from '@material-ui/core/FormControl'
import FormLabel from '@material-ui/core/FormLabel'
import ArrowRightIcon from '@material-ui/icons/ArrowRight'
import RadioButtonCheckedIcon from '@material-ui/icons/RadioButtonChecked'
import RadioButtonUncheckedIcon from '@material-ui/icons/RadioButtonUnchecked'
import CustomExpansionPanel from '../custom-material/expansion-panel/ExpansionPanel'
import CustomExpansionPanelDetails from '../custom-material/expansion-panel/ExpansionPanelDetails'
import { TitleCustomExpansionPanelSummary } from '../custom-material/expansion-panel/ExpansionPanelSummary'
import CustomTypography from '../custom-material/typography/Typography'
import { isEmpty } from 'lodash'
import EmptyStateComponent from '../common/empty-state/EmptyStateComponent'
import Tooltip from '@material-ui/core/Tooltip'
import HelpIcon from '@material-ui/icons/Help'

const styles = theme => ({
  expansionPanelTitle: {
    fontSize: 22,
    fontWeight: 'normal',
    paddingRight: 0,
    display: 'flex',
    alignItems: 'center'
  },
  formControlLabel: {
    fontSize: 15
  },
  radio: {
    paddingRight: 5
  },
  radioIcon: {
    fontSize: 22
  },
  radioGroupFormLabel: {
    fontSize: 16,
    color: 'rgba(0, 0, 0, 0.87)',
    display: 'flex',
    alignItems: 'center'
  },
  helpIcon: {
    marginLeft: 6,
    fontSize: 22,
    color: '#00ACEF'
  }
})

const HOME_PAGE_NAME = {
  'Ipd': 'Life-Cycle Insights',
  'RxStrategy': 'Payer & Provider Insights',
  'CodeSource': 'CODESOURxCE',
  'Forecasting': 'Market & Financial Insights',
  'BudgetImpact': 'Budget Impact'
}

// backcompat until new API is released
const isTherapeuticInsightsUser = (claims) => {
  if (!claims || !claims.length) return false
  return claims.includes('TherapeuticInsights') && !claims.includes('SiteAdmin_InternalUser')
}

const DatabasePreferencesExpansionPanel = ({classes, databasePreferences, updateDatabasePreferences, claims}) => {
  if (new Date() < new Date('2026-08-14') && !isTherapeuticInsightsUser(claims)) {
    return null
  }
  if (isEmpty(databasePreferences) || (isEmpty(databasePreferences.homePage) && isEmpty(databasePreferences.regions))) {
    return null
  }

  return (
    <CustomExpansionPanel>
      <TitleCustomExpansionPanelSummary expandIcon={<ArrowRightIcon style={{fontSize: 50}} />}>
        <CustomTypography className={classes.expansionPanelTitle}>Your Database Preferences</CustomTypography>
      </TitleCustomExpansionPanelSummary>
      <CustomExpansionPanelDetails style={{paddingTop: 16, paddingBottom: 16}}>
          <React.Fragment>
            <FormControl component='fieldset' className={classes.formControl}>
              <FormLabel className={classes.radioGroupFormLabel}>Choose your default home page:</FormLabel>
              {!isEmpty(databasePreferences.homePage) && !isEmpty(databasePreferences.homePage.values)
                ? <RadioGroup
                  aria-label='Home'
                  name='home'
                  value={(databasePreferences.homePage.values.find(x => x.selected === true) || {}).id}
                  onChange={updateDatabasePreferences('homePage', (databasePreferences.homePage.links.find(link => link.rel === 'select') || {}).href)}
                  row
                >
                  {databasePreferences.homePage.values.map((value, i) => (
                    <FormControlLabel
                      key={i}
                      value={value.id}
                      classes={{label: classes.formControlLabel}}
                      control={
                        <Radio
                          className={classes.radio}
                          checkedIcon={<RadioButtonCheckedIcon className={classes.radioIcon} />}
                          icon={<RadioButtonUncheckedIcon className={classes.radioIcon} />}
                        />
                      }
                      label={HOME_PAGE_NAME[value.id] || value.name}
                    />
                  ))}
                </RadioGroup>
                : <EmptyStateComponent title='No home page preferences found' />
              }
            </FormControl>
            <br />
            {!isEmpty(databasePreferences.regions) && !isEmpty(databasePreferences.regions.values)
              ? <FormControl component='fieldset' className={classes.formControl}>
                <FormLabel className={classes.radioGroupFormLabel}>
                  Choose your default Life-Cycle Insights region:
                  <Tooltip title='Choosing a default region determines your Life-Cycle Insights web portal views, including drug tearsheets, search results, and homepage view, to the chosen region. You will still have access to your other contracted regions within a few clicks.'
                    placement='right'><HelpIcon className={classes.helpIcon} />
                  </Tooltip>
                </FormLabel>
                <RadioGroup
                  aria-label='Region'
                  name='region'
                  value={(databasePreferences.regions.values.find(x => x.selected === true) || {}).id}
                  onChange={updateDatabasePreferences('regions', (databasePreferences.regions.links.find(link => link.rel === 'select') || {}).href)}
                  row
                >
                  {databasePreferences.regions.values.map((value, i) => (
                    <FormControlLabel
                      key={i}
                      value={value.id}
                      classes={{label: classes.formControlLabel}}
                      control={
                        <Radio
                          className={classes.radio}
                          checkedIcon={<RadioButtonCheckedIcon className={classes.radioIcon} />}
                          icon={<RadioButtonUncheckedIcon className={classes.radioIcon} />}
                        />
                      }
                      label={value.name}
                    />
                  ))}
                </RadioGroup>
              </FormControl>
              : null
            }
        </React.Fragment>
      </CustomExpansionPanelDetails>
    </CustomExpansionPanel>
  )
}

DatabasePreferencesExpansionPanel.propTypes = {
  classes: PropTypes.object.isRequired,
  databasePreferences: PropTypes.object,
  updateDatabasePreferences: PropTypes.func.isRequired,
  claims: PropTypes.arrayOf(PropTypes.string).isRequired
}

export default withStyles(styles)(DatabasePreferencesExpansionPanel)
